const speciesList = [
    { value: "Dog", label: "Dog" },
    { value: "Cat", label: "Cat" },
    { value: "Rabbit", label: "Rabbit" },
    { value: "Ferret", label: "Ferret" },
];

export { speciesList };
